import router, {resetRouter} from './router'
import store from './store'
import {loginByToken} from './api/login'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式

// permissiom judge
function hasPermission(roles, permissionRoles) {
    if (roles.indexOf('admin') >= 0) return true // admin权限 直接通过
    if (!permissionRoles) return true
    return roles.some(role => permissionRoles.indexOf(role) >= 0)
}

// register global progress.
const whiteList = ['/login', '/authredirect', "/home", "/selectCompany", "/selectInvestment", "/selectPolicy", "/selectPark","/wechat"]// 不重定向白名单
router.beforeEach((to, from, next) => {
    NProgress.start() // 开启Progress
    console.log("token值="+store.getters.token)
    if (store.getters.token) { // 判断是否有token
        if (to.path === '/login') {
            next({path: '/'})
        } else {
            if (store.getters.roles.length === 0) {
                try {
                    //对于工商详情特殊处理
                    if (to.fullPath.indexOf("adt/company/search") > 0) {
                        let arr = to.fullPath.split("?");
                        if(arr[1] !== undefined && arr[1] !== null){
                            let arr1 = arr[1].split("&");
                            let companyParam = {};
                            arr1.forEach((e,index)=>{
                                if(index === 1){
                                    let arr2 =e.split("=");
                                    companyParam.search = decodeURIComponent(arr2[1]);
                                }
                                if(index === 2){
                                    let arr2 =e.split("=");
                                    companyParam.accu = arr2[1];
                                }
                            });
                            store.dispatch('setCompanyParam',companyParam).then(() => {
                            })
                        }
                    }
                }catch (e) {
                    console.log(e)
                }
                // 判断当前用户是否已拉取完user_info信息
                store.dispatch('GetInfo').then(res => { // 拉取user_info
                    const roles = res.data.role;
                    store.dispatch('setUrl', res.data.url).then(() => {
                    }).catch(err => {
                        this.$message.error(err);
                    });
                    store.dispatch('GenerateRoutes', {roles}).then(() => { // 生成可访问的路由表
                        resetRouter();
                        router.addRoutes(store.getters.addRouters) // 动态添加可访问路由表
                        next({...to}) // hack方法 确保addRoutes已完成
                    })

                }).catch(() => {
                    store.dispatch('FedLogOut').then(() => {
                        next({path: '/home'})
                    })
                })
            } else {
                store.dispatch('getNowRoutes', to);
                if (hasPermission(store.getters.roles, to.meta.role)) {
                    next()//
                } else {
                    next({path: '/', query: {noGoBack: true}})
                }
            }
        }
    } else {
        let token = "";
        if (to.fullPath.indexOf("?") > 0) {
            if (to.fullPath.indexOf("adt/company/search") > 0) {
                let arr = to.fullPath.split("?");
                if(arr[1] !== undefined && arr[1] !== null){
                    let arr1 = arr[1].split("&");
                    let companyParam = {};
                    arr1.forEach((e,index)=>{
                        if(index === 0){
                            let arr2 =e.split("=");
                            token = arr2[1]
                        }
                    });
                }
            }else {
                let arr = to.fullPath.split("?");
                if(arr[1].indexOf("=") > 0){
                    let arr1 = arr[1].split("=");
                    token = arr1[1];
                }
            }
        }
        if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
            next()
            NProgress.done() // 在hash模式下 改变手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
        } else {
            if (token.length != 0){
                store.dispatch('setToken', token).then(() => {
                }).catch(err => {
                    this.$message.error(err);
                });
                store.dispatch('setFirstFlag', 1).then(() => {
                }).catch(err => {
                    this.$message.error(err);
                });
                // store.dispatch('setNextPage', page).then(() => {
                // }).catch(err => {
                //     this.$message.error(err);
                // });
                next(to.fullPath)
                NProgress.done()
            }else {
                location.href = process.env.BASE_API+"signin";
                // next('/home') // 否则全部重定向到登录页
                NProgress.done() // 在hash模式下 改变手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
            }
        }
    }
})

router.afterEach(() => {
    NProgress.done() // 结束Progress
})



// WEBPACK FOOTER //
// ./src/login.js